export default "__VITE_ASSET__dee48362__"